import React from 'react'
import { Navbar } from '../../ui/Navbar/Navbar'

export const Header = () => {
  return (
   <Navbar/>
  )
}
